/** Тексты для промо по статусу расписания / лимита. */

export type PromoScheduleStatus = "ok" | "not_started" | "expired" | "limit";

function formatRuDate(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString("ru-RU", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function promoScheduleCopy(input: {
  status?: PromoScheduleStatus | null;
  startsAt?: string | null;
  expiresAt?: string | null;
  benefitLabel?: string | null;
  kind?: "credits" | "discount";
}): {
  isUnavailable: boolean;
  title: string;
  description: string;
  ctaLabel: string;
  bannerTitle: string;
  bannerHint: string;
} {
  const status = input.status ?? "ok";
  const start = formatRuDate(input.startsAt);
  const end = formatRuDate(input.expiresAt);
  const benefit = input.benefitLabel?.trim() || "Промо";
  const kindLabel = input.kind === "discount" ? "скидка" : "подарок";

  if (status === "not_started") {
    return {
      isUnavailable: true,
      title: "Акция ещё не началась",
      description: start
        ? `${benefit} станет доступна с ${start}. Сохраните ссылку и загляните позже.`
        : `${benefit} скоро станет доступна. Сохраните ссылку и загляните позже.`,
      ctaLabel: "Понятно",
      bannerTitle: "Акция ещё не началась",
      bannerHint: start
        ? `Промокод можно будет активировать с ${start}.`
        : "Промокод пока нельзя активировать — акция ещё не стартовала.",
    };
  }

  if (status === "expired") {
    return {
      isUnavailable: true,
      title: "Акция уже закончилась",
      description: end
        ? `Срок действия истёк ${end}. Этот ${kindLabel} больше недоступен.`
        : `Срок действия промокода истёк. Этот ${kindLabel} больше недоступен.`,
      ctaLabel: "Понятно",
      bannerTitle: "Акция уже закончилась",
      bannerHint: end
        ? `Промокод действовал до ${end} и больше не активируется.`
        : "Срок промокода истёк — активировать его уже нельзя.",
    };
  }

  if (status === "limit") {
    return {
      isUnavailable: true,
      title: "Акция завершена",
      description: `Лимит активаций исчерпан. Этот ${kindLabel} больше недоступен.`,
      ctaLabel: "Понятно",
      bannerTitle: "Лимит промокода исчерпан",
      bannerHint: "Регистрация доступна, но этот промокод уже нельзя активировать.",
    };
  }

  return {
    isUnavailable: false,
    title: "",
    description: "",
    ctaLabel: "",
    bannerTitle: "",
    bannerHint: "",
  };
}
